import { resourceFromAttributes } from "@opentelemetry/resources";
import { browserAttributes } from "~/openTelemetry/resources/browserAttributes";
import { serviceResource } from "~/openTelemetry/resources/serviceResource";

export const portalResource = resourceFromAttributes({}).merge(serviceResource).merge(browserAttributes);
